import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import Card from 'transfix-ui/components/Card'
import { makeStyles } from 'transfix-ui/core'
import Typography from 'transfix-ui/core/Typography'

export interface ISavedLanesSummaryCardProps {
  savedLanes: number
}

const useSavedLanesSummaryCardStyles = makeStyles(theme => ({
  manageButton: {
    paddingTop: theme.spacing(2),
  },
}))

const SavedLanesSummaryCard = memo<ISavedLanesSummaryCardProps>(({ savedLanes }) => {
  const classes = useSavedLanesSummaryCardStyles()
  const history = useHistory()

  const manageButtonHandler = () => {
    history.push('/transfix-lanes')
  }
  const savedLanesText = savedLanes !== 1 ? `${savedLanes} Saved Lanes` : `${savedLanes} Saved Lane`
  return (
    <Card>
      <Typography variant='h3' align='left'>
        Saved Lanes
      </Typography>
      <Typography variant='body2'>
        You currently have <b>{savedLanesText}</b>. We&apos;ll keep looking for shippers with loads
        that match your preferences.
      </Typography>
      <div className={classes.manageButton}>
        <Button variant='text' onClick={manageButtonHandler}>
          Manage
        </Button>
      </div>
    </Card>
  )
})

export default SavedLanesSummaryCard
